/**
 * Singleton @strapi/client instance for the Macumba CMS.
 *
 * The CMS serves public content (subscription plans, popular regions, etc.)
 * so no auth token is required — public permissions are enabled in Strapi.
 *
 * Base URL comes from VITE_CMS_URL env var:
 *   local dev:   http://localhost:1338
 *   production:  https://cms.macumbatravel.com
 */
import { strapi } from '@strapi/client'

const BASE_URL = (import.meta.env.VITE_CMS_URL || 'http://localhost:1338') + '/api'

let _client = null

export function getCmsClient() {
  if (!_client) {
    _client = strapi({ baseURL: BASE_URL })
  }
  return _client
}
